import { useParams } from 'react-router-dom';
import DashboardBreadcrumbs from 'domain/projects/newProject/shared/breadcrumbs/DashboardBreadcrumbs';
import { ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useNewProjectUrl } from 'domain/shared/newProject';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';
import { ClientPortalTask } from '../../types';

const ClientPortalTaskBreadcrumbs = ({ task, projectName }: { task: ClientPortalTask; projectName?: string }) => {
  const { id, taskId } = useParams();
  const { getProjectClientPortalUrl } = useNewProjectUrl();

  return (
    <DashboardBreadcrumbs>
      <ListBreadcrumbItem entity={projectName || EMPTY_VALUE_INDICATOR} link={getProjectClientPortalUrl(id!)} />
      <ListBreadcrumbItem entity={task?.alias ?? task?.id} link={getProjectClientPortalUrl(taskId)} />
    </DashboardBreadcrumbs>
  );
};
export default ClientPortalTaskBreadcrumbs;
